<template>
  <span class="json-view-dialog-trigger">
    <el-button
      type="text"
      size="small"
      :disabled="disabled"
      @click="visible = true"
    >
      {{ hasData ? buttonText : '-' }}
    </el-button>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      :width="dialogWidth"
      append-to-body
      :before-close="handleClose"
      custom-class="json-view-dialog"
      @closed="visible = false"
    >
      <json-key-value-panel
        v-if="useKeyValueLayout"
        :data="displayValue"
        :field-labels="mergedFieldLabels"
        :field-priority="fieldPriority"
        class="json-view-dialog-body"
      />
      <json-nested-table
        v-else
        :data="content"
        :view-key="dataTab"
        :max-height="maxHeight"
        class="json-view-dialog-body"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">关闭</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
import JsonKeyValuePanel from '@/components/JsonKeyValuePanel';
import JsonNestedTable from '@/components/JsonNestedTable';
import { getPushDataFieldLabels, getPushDataFieldPriority, normalizePushDataForView } from '@/utils/poOtherDataView';
import { isSingleRowKeyValueData, parseJsonValue } from '@/utils/jsonNestedTable';

export default {
  name: 'JsonViewDialog',
  components: { JsonKeyValuePanel, JsonNestedTable },
  props: {
    content: { default: null },
    /** 综合 PO：当前 Tab，用于 data 结构归一化 */
    dataTab: { type: String, default: '' },
    title: { type: String, default: '详情' },
    buttonText: { type: String, default: '查看详情' },
    width: { type: String, default: '75%' },
    maxHeight: { type: Number, default: 520 },
    /** 单行 data 时用 key:value 双列表单，不用表格 */
    singleRowAsKeyValue: { type: Boolean, default: true },
  },
  data() {
    return { visible: false };
  },
  computed: {
    displayValue() {
      if (this.dataTab) {
        return normalizePushDataForView(this.dataTab, this.content);
      }
      return parseJsonValue(this.content);
    },
    mergedFieldLabels() {
      const extra = this.dataTab ? getPushDataFieldLabels(this.dataTab) : {};
      return extra;
    },
    fieldPriority() {
      return this.dataTab ? getPushDataFieldPriority(this.dataTab) : [];
    },
    useKeyValueLayout() {
      if (!this.singleRowAsKeyValue) return false;
      return isSingleRowKeyValueData(this.displayValue);
    },
    dialogWidth() {
      return this.useKeyValueLayout ? '68%' : this.width;
    },
    hasData() {
      const v = parseJsonValue(this.content);
      if (v === null || v === undefined || v === '') return false;
      if (Array.isArray(v) && v.length === 0) return false;
      if (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0) return false;
      return true;
    },
    disabled() {
      return !this.hasData;
    },
  },
  methods: {
    handleClose(done) {
      done();
    },
  },
};
</script>
